// extracted by mini-css-extract-plugin
export default {"dragging":"_2VMr8"};